import { getActiveApiBaseUrl } from '../api/apiBaseConfig';

export type ServiceImageSource = {
  image?: string | null;
  service_image?: string | null;
  thumbnail?: string | null;
  photo?: string | null;
  [key: string]: unknown;
};

/** Absolute HTTP(S) URL for a service photo, or null if API only sent icon metadata. */
export function getServiceImageUrl(item: ServiceImageSource | null | undefined): string | null {
  if (!item) return null;
  const candidates = [
    item.image,
    item.service_image,
    item.thumbnail,
    item.photo,
  ];
  for (const raw of candidates) {
    const url = resolveImageString(raw);
    if (url) return url;
  }
  return null;
}

function resolveImageString(raw: unknown): string | null {
  if (raw == null) return null;
  if (typeof raw === 'object' && raw !== null) {
    const o = raw as { url?: string; src?: string };
    return resolveImageString(o.url ?? o.src);
  }
  if (typeof raw !== 'string') return null;
  const trimmed = raw.trim();
  if (!trimmed || trimmed.startsWith('{') || trimmed.startsWith('[')) return null;
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) return trimmed;
  const base = getActiveApiBaseUrl().replace(/\/$/, '');
  if (!base) return null;
  const path = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
  return `${base}${path}`;
}

/** @deprecated Use getServiceImageUrl — returns null when API has no image (no stock fallback). */
export function getServiceImageUri(item: ServiceImageSource | null | undefined): string | null {
  return getServiceImageUrl(item);
}
